import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// VoxVault standardized button variants (Phase B)
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // Primary CTA: white-on-black (most form submit / "Save" actions)
        default:
          "bg-white text-black shadow hover:bg-white/90",
        // Action CTA: teal accent (search buttons, hero CTAs)
        action:
          "bg-accent text-black shadow hover:bg-accent/90",
        // Destructive: red (delete, report submit)
        destructive:
          "bg-red-500 text-white shadow-sm hover:bg-red-600",
        // Outline: subtle border, transparent background
        outline:
          "border border-white/20 text-white bg-transparent shadow-sm hover:bg-white/5",
        // Secondary: muted surface
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        // Ghost: text-only hover
        ghost: "text-white/70 hover:text-white hover:bg-white/5",
        // Link: underlined text
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
